// @flow

import { h }             from "preact";
import { PureComponent,
         ScrollTop }     from "shared-components";
import styles            from "./styles.scss";
import classNames        from "classnames";
import Helmet            from "preact-helmet";
import { connect }       from "preact-redux";

import Redirect from "../../components/Redirect";

@connect(
  state => ({
    loggedIn: state.customer.loggedIn,
  })
)
export default class Login extends PureComponent {
  render({ loggedIn }: Props, state: any, { t }: Context) {
    if (loggedIn) {
      return <Redirect to="/" />;
    }

    return (
      <div class={styles.block}>
        <ScrollTop />

        <Helmet title={t("LOGIN.TITLE")} />
      </div>
    );
  }
}
